import { useEffect, useState } from 'react';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-4 md:right-8 z-40 w-11 h-11 rounded-full bg-primary-600 text-background-50 flex items-center justify-center hover:bg-primary-700 transition-colors cursor-pointer"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}